/**
 * Named tracker layout presets — one-click templates for known race/tournament
 * configurations. Each preset is the same shape as a SharedLayoutPayload.
 */
import type { SharedLayoutPayload } from '@/lib/tracker-layout';

export interface LayoutPreset extends SharedLayoutPayload {
  /** Stable identifier (also used as React key). */
  id: string;
  /** Human-readable label for the dropdown. */
  label: string;
  /** Optional one-liner description. */
  description?: string;
}

export const LAYOUT_PRESETS: LayoutPreset[] = [
  {
    id: 'mixed-pool-s5',
    label: 'Mixed Pool — Season 5',
    description:
      '5 WoTH · 3 foolish · 3 always + 1 dual + 2 entrance · 2 dual + 2 entrance + 2 sometimes · starts with Zelda’s Letter, Farore’s Wind, Fairy Ocarina',
    nbGoals: 5,
    isWoth: true,
    nbBarren: 3,
    nbSometimes: 6,
    alwaysHintNames: [
      'DMT Biggoron',
      'ZR Frogs Ocarina Game',
      'KF Links House Cow',
      'Deku Theater Rewards',
      'Forest Boss Door Entrance',
      'Shadow Boss Door Entrance',
    ],
    // 2 dual + 2 entrance + 2 regular
    sometimesKinds: ['dual', 'dual', 'entrance', 'entrance', 'regular', 'regular'],
    // Starting inventory: Zelda's Letter (stage 3 of child trade), Farore's Wind, Fairy Ocarina
    startingItems: [
      { id: 'Oot_ChildTrade', state: 3 },
      { id: 'Oot_FaroresWind' },
      { id: 'Oot_Ocarina', state: 1 },
    ],
  },
];
